<template>
<modal @close="$emit('close')">
    <template slot="header">
        Set Letter Date
    </template>

    <template slot="content">
        <div class="flex jc-sb">
            <p class="mb-0 mr-2">Set the date that should appear on each reminder letter:</p>

            <datepicker :inline="true" :typeable="true" v-model="date" format="MM/dd/yyyy" />
        </div>
    </template>

    <template slot="footer">
        <div class="flex jc-fe">
            <button type="button" @click="onSave">Set</button>
        </div>
    </template>
</modal>
</template>

<script>
export default {
    name: "reminder-letter-modal",

    data () {
        return {
            date: new Date()
        }
    },

    methods: {
        onSave () {
            this.$emit("save", this.date)
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SendLetterDateModal.vue